<template>
  <div class="filters-sidebar card">
    <CartIcon class="cartIcon" />
    <div class="filters-sidebar-header">
      <h4>FILTER OP:</h4>
    </div>
    <div class="filters-sidebar-content">
      <CategoryFilters
        :value="filters.categories"
        @change="handleSlectCategory"
      />
      <!-- <PriceFilters
        class="mt-5"
        :values="[filters.min_price, filters.max_price]"
        :sliderMax="sliderMax"
        @drag="setPriceRange"
      /> -->
      <!-- <div class="text-center mb-5">
        {{ formatCurrency(filters.min_price, true) }} —
        {{ formatCurrency(filters.max_price, true) }}
      </div> -->
      <button
        class="btn btn-secondary"
        style="margin: 0 auto; width: 100%"
        @click="handlClearFilters"
      >
        Filters wissen
      </button>
    </div>
  </div>
</template>

<script>
import CartIcon from "@/components/CartIcon";
import WooCommerce from "@/services/wooservice.js";
import CategoryFilters from "./CategoryFilters";
import PriceFilters from "./PriceFilters";
import { formatCurrency } from "@/helpers/formatCurrency";

export default {
  name: "Filters",
  components: { CategoryFilters, PriceFilters, CartIcon },
  data() {
    return {
      filters: {
        categories: [],
        min_price: null,
        max_price: null,
      },
      sliderMax: 0,
    };
  },

  methods: {
    formatCurrency,
    setPriceRange(e) {
      const newFilters = {
        ...this.filters,
        ...e,
        orderby: "price",
      };
      this.filters = newFilters;
      this.setProductListToFirst();
      this.filterStoreProducts(newFilters);
    },

    filterStoreProducts(newFilters) {
      this.$store.dispatch("products/getFilteredProducts", {
        filters: newFilters,
      });
      this.$store.commit("products/setFilters", newFilters);
    },

    handleSlectCategory(e) {
      this.filters.categories = e;
      this.filterStoreProducts(this.filters);

      console.log('this.$route.name',this.$route.name);

      if (this.$route.name === "products") {
        this.$router.replace({
          name: "products",
          query: {
            product_page: this.$router.query?.product_page || 1,
            filters: JSON.stringify({
              categories: this.filters.categories,
            }),
          },
        });
      } else {
        this.setProductListToFirst();
      }
    },

    handlClearFilters() {
      this.filters = {
        categories: [],
        min_price: 0,
        max_price: this.sliderMax,
      };
      this.$store.commit("products/clearFilteredProducts");
      this.$store.commit("products/setFilters", this.filters);
    },
    setProductListToFirst() {
  console.log('calling setProductListToFirst:');
  this.$router.replace({
    name: this.$route.name,
    query: {
      ...this.$route.query,  // Note: changed from this.$router.query to this.$route.query
      product_page: 1,
    },
  }).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
    // Navigation duplications can be safely ignored
  });
},
  },

  computed: {
    queryFilters() {
      if (this.$route.query?.filters) {
        if (!isNaN(this.$route.query.filters)){
          // added the code to accept filter with category id
          return {"categories":[parseInt(this.$route.query.filters)]}
        }
        return JSON.parse(this.$route.query.filters);
      }
    },
    cachedFilters() {
      return this.$store.getters["products/filters"];
    },
  },

  watch: {
    queryFilters: {
      async handler(newVal) {
        if (newVal) {
          this.filters = newVal;
          if (!this.$store.getters["categories/categories"]?.length) {
            this.$store
              .dispatch("categories/getCategories")
              .then(() => this.filterStoreProducts(newVal));
          } else {
            this.filterStoreProducts(newVal);
          }
        }
      },
      deep: true,
      immediate: true,
    },
    cachedFilters: {
      handler(newVal) {
        this.filters = {
          ...newVal,
        };
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    try {
      const getMaxPrice = await WooCommerce.get("products", {
        order: "desc",
        orderby: "price",
        per_page: 1,
        page: 1,
      });
      this.sliderMax = +getMaxPrice.data[0].price;
      this.filters = {
        ...this.filters,
        // min_price: 0,
        // max_price: this.filters.max_price || this.sliderMax,
      };
    } catch (err) {
      console.log(err);
    }
  },
};
</script>

<style>
.filters-sidebar {
  border-radius: 10px !important;
  overflow: hidden;
}

.filters-sidebar-header,
.filters-sidebar-content {
  padding: 1rem;
  overflow: hidden;
}

.filters-sidebar-content {
  padding: 2.5rem;
}

.filters-sidebar-header {
  background-color: var(--theme);
}

.filters-sidebar-header h4 {
  text-align: center;
  color: white;
  margin-bottom: 0;
  font-weight: bold;
}
</style>
